import { createSlice } from "@reduxjs/toolkit";

export const appointmentSteps = {
    SELECT_APPOINTMENT: 1,
    SELECT_CENTRE: 2,
    SELECT_DATE: 3,
    SELECT_PATIENT: 4,
    PAYMENT_CONFIRMATION: 5,
};

const initialState = {
    currentStep: appointmentSteps.SELECT_APPOINTMENT,
    testDetails: {},
    centreDetails: {},
    selectedDateTime: {},
    checkoutId: "",
    discountAmount: 0,
    paymentId: "",
    mobileNo: null,
};

const petCtAppoinmentSliceNew = createSlice({
    name: "appointmentNew",
    initialState,
    reducers: {
        updateCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        updateTestDetails: (state, action) => {
            state.testDetails = action.payload;
        },
        updateCentreDetails: (state, action) => {
            state.centreDetails = action.payload;
        },
        updateSelectedDateTime: (state, action) => {
            state.selectedDateTime = action.payload;
        },
        updateCheckoutId: (state, action) => {
            state.checkoutId = action.payload;
        },
        updateDiscountAmount: (state, action) => {
            state.discountAmount = action.payload;
        },
        updatePaymentId: (state, action) => {
            state.paymentId = action.payload;
        },
        updateMobileNo: (state, action) => {
            state.mobileNo = action.payload;
        },
        resetAppointment: () => initialState,
    },
});

export const {
    updateCurrentStep,
    updateTestDetails,
    updateCentreDetails,
    updateSelectedDateTime,
    resetAppointment,
    updateCheckoutId,
    updateDiscountAmount,
    updatePaymentId,
    updateMobileNo,
} = petCtAppoinmentSliceNew.actions;

export const appointmentNewReducer = petCtAppoinmentSliceNew.reducer;
